import { render, staticRenderFns } from "./SearchArticlePreviewBlock.vue?vue&type=template&id=5f4eb606&scoped=true&"
import script from "./SearchArticlePreviewBlock.vue?vue&type=script&lang=js&"
export * from "./SearchArticlePreviewBlock.vue?vue&type=script&lang=js&"
import style0 from "./SearchArticlePreviewBlock.vue?vue&type=style&index=0&id=5f4eb606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4eb606",
  null
  
)

export default component.exports